import { Cookies } from "react-cookie";
import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../../constants/cookieNames";
import { ENDPOINTS_AUTH, URL_AUTH } from "../../../constants/api_endpoints";
import { IRefreshTokenResponse } from "../../../types/authTypes";

const removeCookieAndReload = () => {
	new Cookies().remove(ACCESS_TOKEN, { path: "/" });
	new Cookies().remove(REFRESH_TOKEN, { path: "/" });
	window.location.reload();
};

const cookies = new Cookies();

export const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
	const baseQuery = fetchBaseQuery({
		baseUrl: "/",
		headers: {
			"x-access-token": cookies.get(ACCESS_TOKEN),
		},
	});
	let result = await baseQuery(args, api, extraOptions);

	// Пытаемся обновить токен если прострочен основной
	if (result.error?.status === 401) {
		const refreshResult = await baseQuery(
			{
				url: `${URL_AUTH}/${ENDPOINTS_AUTH.REFRESH}`,
				method: "GET",
				headers: {
					"x-refresh-token": cookies.get(REFRESH_TOKEN),
				},
			},
			api,
			extraOptions
		);

		// в случае успешного повторного запроса кладем в куки новую пару токенов
		if (refreshResult.data) {
			const data = refreshResult.data as IRefreshTokenResponse;
			cookies.set(ACCESS_TOKEN, data["x-access-token"], { path: "/", maxAge: 86_400 });
			cookies.set(REFRESH_TOKEN, data["x-refresh-token"], { path: "/", maxAge: 2_592_000 });

			// Повторяем оригинальный запрос с новым токеном
			result = await baseQuery(args, api, extraOptions);
		} else {
			// если запрос не сработал -разлогиниваемся
			removeCookieAndReload();
			return result;
		}
	}
	return result;
};
